import React, { useState } from "react";
import { FaRegCopy, FaRegTrashAlt } from "react-icons/fa";
import { MdEdit } from "react-icons/md";
import { Button, Col, Input, Row } from "reactstrap";
import { useDispatch } from "react-redux";
import "../Styles/Packages.css";
import { setSelectedPrice } from "../../../../redux/slices/MsgSlice";

const CreatedPackages = ({
  dealPackage,
  handleEditPackage,
  handleDeletePackage,
  editedPackageIndex,
  handleDuplicatePackage,
  state,
  checked,
  setEditedPackageIndex,
}) => {
  const [showAllPackages, setShowAllPackages] = useState({});
  const dispatch = useDispatch();

  const handleShowAllPackages = (idx) => {
    setShowAllPackages((prev) => ({
      ...prev,
      [idx]: !prev[idx],
    }));
  };

  return (
    <div className="created-packages-wrapper">
      <Row className="align-items-center justify-content-center">
        <div className="packages-scrollable-row">
          {dealPackage.map((pkg, idx) => (
            <Col
              key={idx}
              className="package-column"
              style={{ animationDelay: `${idx * 0.06}s` }}
            >
              <div
                className={`package-card-container ${
                  editedPackageIndex === idx ? "selected" : ""
                }`}
                onClick={() => {
                  dispatch(setSelectedPrice(pkg?.totalPrice));
                  setEditedPackageIndex(idx);
                }}
              >
                <div className="package-header-section">
                  <h5 className="package-title-text">
                    {pkg.title || "Untitled Package"}
                  </h5>
                  <div className="package-content-area">
                    {pkg.packages
                      .slice(0, showAllPackages[idx] ? pkg.packages.length : 2)
                      .map((packageItem, index) => (
                        <div key={index} className="package-item-container">
                          <Input
                            type="checkbox"
                            className="mt-0"
                            checked={packageItem.checked}
                            disabled
                          />
                          <div className="package-item-text">
                            <span className="package-item-title-text">
                              {packageItem.title}
                            </span>
                            <p className="package-item-description">
                              {packageItem.description}
                            </p>
                          </div>
                        </div>
                      ))}
                    {pkg.packages.length > 2 && (
                      <p
                        className="view-toggle-link"
                        onClick={() => handleShowAllPackages(idx)}
                      >
                        {showAllPackages[idx] ? "Hide" : "View All"}
                      </p>
                    )}
                  </div>
                </div>
                <div className="package-info-panel">
                  <div>
                    Guest Count: <strong>{pkg.guestCount}</strong>
                  </div>
                  <div>
                    Total Price: <strong>${parseInt(pkg.totalPrice)}</strong>
                  </div>
                </div>
              </div>

              {(state?.invoice ? checked : true) && (
                <div className="package-actions-panel">
                  <Button
                    className="action-button primary"
                    onClick={() => handleDuplicatePackage(idx)}
                  >
                    <FaRegCopy />
                  </Button>
                  <Button
                    className="action-button success"
                    onClick={() => handleEditPackage(idx)}
                  >
                    <MdEdit />
                  </Button>
                  <Button
                    className="action-button danger"
                    onClick={() => handleDeletePackage(idx)}
                  >
                    <FaRegTrashAlt />
                  </Button>
                </div>
              )}
            </Col>
          ))}
        </div>
      </Row>
    </div>
  );
};

export default CreatedPackages;
